import { z } from "zod";
import { elementTypeEnumSchema } from "../enumSchemas";

const apiProductDataSchema = z.object({
    productType: elementTypeEnumSchema,
    mappingId: z.string().nullable()
  });

export default apiProductDataSchema;